export const dash = (str: string) => {
  const lastFour = str.slice(-4);
  const prev = str.slice(0, -4);
  return `${prev}‑${lastFour}`;
};
